import { hideBurgerMenu, showBurgerMenu } from "@global-state/global/slice";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "store/hooks";
import style from "./MenuButton.module.scss";
import cn from "classnames";

export function MenuButton() {
    const isShowBurgerMenu = useAppSelector(state => state.global.isShowBurgerMenu)

    const dispatch = useAppDispatch();
    const location = useLocation();

    useEffect(() => {
        function handleClick(e: any) {
            if (!e.target.closest("[data-burger]")) {
                dispatch(hideBurgerMenu());
            }
        }

        document.documentElement.addEventListener("click", handleClick);

        return () => {
            document.documentElement.removeEventListener("click", handleClick);
        };
    }, []);

    useEffect(() => {
        dispatch(hideBurgerMenu());
    }, [location])

    return (
        <button
            data-burger
            className={cn(style.menuButton, isShowBurgerMenu && style.menuButton_show)}
            onClick={() => {
                if (isShowBurgerMenu) {
                    dispatch(hideBurgerMenu());
                } else {
                    dispatch(showBurgerMenu());
                }
            }}
        >
            <div></div>
            <div></div>
            <div></div>
        </button>
    )
}